export default __webpack_public_path__ + "static/media/salary-adjustment.439ee0fa.svg";